module.exports = __webpack_public_path__ + "c32166120d82280ed5ce48c4534224f8.png";